import { CoverImageContainer } from "./style";

type CoverImageProps = {
  impage_id: string;
  image_path: string;
  link: string;
};

const CoverImage: React.FC<CoverImageProps> = ({
  image_path,
  link,
  impage_id,
}) => {
  return (
    <CoverImageContainer>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        key={`couver_image_${impage_id}`}
      >
        <img src={image_path} alt="Foto de perfil" />
      </a>
    </CoverImageContainer>
  );
};

export { CoverImage };
